import React from 'react';
import ReactDOM from 'react-dom';
import App from './App'; // Certifique-se de que o caminho está correto
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
